import { render, staticRenderFns } from "./KitchenChargesTable.vue?vue&type=template&id=4818fff3&scoped=true"
import script from "./KitchenChargesTable.vue?vue&type=script&lang=js"
export * from "./KitchenChargesTable.vue?vue&type=script&lang=js"
import style0 from "./KitchenChargesTable.vue?vue&type=style&index=0&id=4818fff3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818fff3",
  null
  
)

export default component.exports